import { Pipe, PipeTransform } from '@angular/core';
import { ProductTypeEnum, translationKeys } from '../../../core';

@Pipe({
  name: 'productTypeLabel'
})
export class ProductTypeLabelPipe implements PipeTransform {
  transform(productType: ProductTypeEnum = ProductTypeEnum.SUBSTANCE): string {
    switch (productType) {
      case ProductTypeEnum.COMPONENT:
        return translationKeys.productDeclaration.html.label.name.component;
      case ProductTypeEnum.SEMICOMPONENT:
        return translationKeys.productDeclaration.html.label.name.semiComponent;
      case ProductTypeEnum.MIXTURE:
        return translationKeys.productDeclaration.html.label.name.mixture;
      case ProductTypeEnum.HOMOGENEOUS_MATERIAL:
        return translationKeys.productDeclaration.html.label.name.homogeneousMaterial;
      case ProductTypeEnum.MATERIAL:
        return translationKeys.productDeclaration.html.label.name.material;
      case ProductTypeEnum.ARTICLE:
        return translationKeys.productDeclaration.html.label.name.article;
      default:
        return translationKeys.productDeclaration.html.label.name.substance;
    }
  }
}
